import { Component, OnInit, Input } from '@angular/core';
import { CardInfo } from '../contact-card-grid.module';


@Component({
  selector: 'msi-contact-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class MsiContactCardComponent implements OnInit {

  @Input() card: CardInfo;

  submenuOpened = false;

  constructor() { }

  ngOnInit() {
  }

  subeMenuToggle() {
    this.submenuOpened = !this.submenuOpened;
  }
}
